module.exports = __webpack_public_path__ + "img/min.e995da6c.svg";